import { Component } from "react";
import "./AppSmallFooter.css";
import Logo from "../Logo";

/**
 * For some pages we need smaller footer to save as much window space as possible.
 * For example, we need it for Video Chat page (ConversationPage).
 * This small footer contains only logo and copyright, no navigation or languages panels.
 */
export default class AppSmallFooter extends Component {
  render() {
    return (
      <div className="app-small-footer">
        <div>
          <Logo />
        </div>
        <div className="copyright">
          Copyright Talaera {new Date().getFullYear()}. All rights reserved.
        </div>
      </div>
    );
  }
}
